import styled from "styled-components";

export const SkeletonPulse = styled.div`
  display: inline-block;
  height: 100%;
  width: 100%;
  border-radius: ${props => (props.bordered ? "16px" : "6px")};
  background: linear-gradient(-90deg, #363636 0%, #484848 80%, #363636 100%);
  background-size: 400% 400%;
  animation: pulse 1.8s ease infinite;
  @keyframes pulse {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }
`;

export const SkeletonLine = styled(SkeletonPulse)`
  width: 5.5em;
  border-radius: 12px;

  &::before {
    content: "\00a0";
  }
`;
